export default __webpack_public_path__ + "static/media/project12.31530df5.png";